import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../atoms/CustomTooltip';

const MoreOptionsMenu = ({
  options,
  size = 'medium',
  disabled = false,
  margin = '-6px 0 0 -8px',
  color = 'white',
  placement = null,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = e => {
    e?.stopPropagation();
    e?.preventDefault();
    setAnchorEl(null);
  };

  return (
    <>
      <CustomTooltip
        title={t('machines.facilities.center_pane.sensor.more_options')}
        placement={placement}
        componentsProps={{
          popper: {
            sx: {
              zIndex: 2000,
            },
          },
        }}
      >
        <IconButton
          sx={{ margin }}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            setAnchorEl(e.currentTarget);
          }}
          size={size}
          disabled={disabled}
        >
          <MoreVert sx={{ color }} />
        </IconButton>
      </CustomTooltip>
      <Menu
        id="more-options"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'more-options-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          zIndex: 2000,
        }}
      >
        {options.map(opt => (
          <MenuItem
            key={opt.label}
            onClick={e => {
              e?.stopPropagation();
              e?.preventDefault();
              handleClose();
              opt.action();
            }}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

MoreOptionsMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
    }),
  ).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  margin: PropTypes.string,
  color: PropTypes.string,
  placement: PropTypes.string,
};

export default MoreOptionsMenu;
